import React from "react";
import PropTypes from "prop-types";
import DynamicBreadcrumbsNav from "./DynamicBreadcrumbsNav";
import cx from "classnames";

import "./DynamicBreadCrumbs.scss";

const DynamicBreadCrumbs = (props) => (
  <div
    className={cx("dynamic-breadcrumb", {
      "dynamic-breadcrumb--transformed": props.needsTransform,
    })}
  >
    <div
      className="dynamic-breadcrumb-inner"
      style={{
        transform: props.transform,
        WebkitTransform: props.transform,
      }}
    >
      {props.items.map((item, index) => (
        <DynamicBreadcrumbsNav
          key={index}
          letter={item.letter}
          bookmark={item.bookmark}
          availableOptions={item.availableOptions}
          defaultCharacter={item.defaultCharacter}
          optionIndex={index}
          setActiveNav={props.setActiveNav}
          isActive={props.activeNav === index}
          setActivePage={props.setActivePage}
          activePage={props.activePage}
          id={item.index + 2}
          onChangeOption={props.handleChangeCharacter}
          values={props.values}
          isHeidelberg={props.isHeidelberg}
          prismicContent={props.prismicContent}
        />
      ))}
    </div>
  </div>
);

DynamicBreadCrumbs.propTypes = {
  prismicContent: PropTypes.object.isRequired,
  transform: PropTypes.string,
  items: PropTypes.array.isRequired,
  setActiveNav: PropTypes.func.isRequired,
  activeNav: PropTypes.number,
  setActivePage: PropTypes.func.isRequired,
  handleChangeCharacter: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  needsTransform: PropTypes.bool.isRequired,
  activePage: PropTypes.number,
  isHeidelberg: PropTypes.bool.isRequired,
};

export default DynamicBreadCrumbs;
